module.exports = __webpack_public_path__ + "img/icon-female.a341b610.svg";